import $ from 'jquery'
import 'fullcalendar'

const Calendar = () => {
  const init = () => {
    $('#wwp3-calendar').fullCalendar({
      header: {
        left: 'prev title next',
        center: '',
        right: 'month,agendaWeek,listMonth',
      },
      buttonText: {
        today: 'heute',
        month: 'Monat',
        week: 'Woche',
        day: 'Tag',
        list: 'Liste',
      },
      locale: 'de',
      displayEventTime: false,
      views: {
        listMonth: {
          type: 'list',
          duration: { weeks: 12 },
          buttonText: 'Liste',
        },
      },
      eventRender: (event, element, view) => {
        $('.fc-content', element).prepend(
          // `<img class="fc-event-img" height="18" width="18" src="${
          event.logo
          // }" />`
        )
      },
      eventSources: [
        {
          url: window.wwp3.ajaxurl,
          type: 'POST',
          data: {
            action: 'wwp3_get_events',
          },
          error: () => {
            console.log('there was an error while fetching events!')
          },
          textColor: '#fff',
        },
      ],
    })
  }

  init()
}

export default Calendar



// WEBPACK FOOTER //
// src/assets/js/front-end/components/calendar.js